class ExpandableList {
    constructor(element) {
        this.button = element.querySelector("[data-expandable-toggle]");
        this.hiddenItems = element.querySelectorAll("[data-expandable-item]");
        this.isExpanded = false;

        if (!this.button || !this.hiddenItems.length) return;

        this.button.addEventListener("click", () => this.toggle());
        this.init();
    }

    init() {
        this.hiddenItems.forEach((item) => {
            item.style.cssText =
                "opacity:0;height:0;overflow:hidden;transition:all 0.1s ease";
        });
    }

    toggle() {
        this.isExpanded = !this.isExpanded;

        this.hiddenItems.forEach((item, i) => {
            setTimeout(() => {
                if (this.isExpanded) {
                    item.style.cssText =
                        "opacity:1;height:auto;overflow:visible;transition:all 0.1s ease";
                } else {
                    item.style.cssText =
                        "opacity:0;height:0;overflow:hidden;transition:all 0.1s ease";
                }
            }, i * 15);
        });

        this.button.textContent = this.isExpanded
            ? this.button.dataset.textLess || "View less"
            : this.button.dataset.textMore || "View more";

        this.button.setAttribute("aria-expanded", this.isExpanded);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document
        .querySelectorAll("[data-expandable-list-container]")
        .forEach((el) => {
            new ExpandableList(el);
        });
});

export default ExpandableList;
